const API_HOST = process.env.REACT_APP_API_URL;
const API = process.env.REACT_APP_API_KEY;

export async function getUser(username, password) {
  const res = await fetch(`${API_HOST}/auth/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      API: API,
    },

    body: JSON.stringify({
      username,
      password,
    }),
  });

  let data;

  try {
    data = await res.json();
  } catch (error) {
    data = {
      ok: false,
      status: res.status,
      error: res.statusText,
    };
  }
  return { ok: res.ok, status: res.status, data };
}

export async function recoverPassword(username) {
  const res = await fetch(`${API_HOST}/usuarios/recover-password`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      API: API,
    },

    body: JSON.stringify({
      username,
    }),
  });

  let data;

  try {
    data = await res.json();
  } catch (error) {
    data = {
      ok: false,
      status: res.status,
      error: res.statusText,
    };
  }
  return { ok: res.ok, status: res.status, data };
}
